






















import Vue from "vue";
import { ILS_YOUTUBE, ILS_FACEBOOK } from "../../constants";

export default Vue.extend({
  name: "FooterMainSocialLinks",
  data() {
    return {
      facebook: ILS_FACEBOOK,
      youtube: ILS_YOUTUBE
    };
  }
});
